// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    id: "1",
    pa: "Doctor Strange in the Multiverse of Madness",
    price: "$32",
  },
  {
    id: "2",
    pa: "Doctor Strange in the Multiverse of Madness",
    price: "$32",
  },
  {
    id: "3",
    pa: "The Bad Guy",
    price: "$6.1",
  },
  {
    id: "4",
    pa: "Sonic the Hedgehog2",
    price: "$32",
  },
  {
    id: "5",
    pa: "Men",
    price: "$32",
  },
  {
    id: "6",
    pa: "Ecverything EveryWhere All at Once",
    price: "$3.1",
  },
];
